import { sendGenericEmail } from "../../api/TamtamAPI/emailing";
import { emailRequest, emailSuccess, emailFailure } from "../actions/emailing";

export const sendGenericEmailThunk = (
  token,
  recipients,
  type,
  lng,
  dynamicFields,
  organization,
  files
) => {
  return dispatch => {
    dispatch(emailRequest());
    try {
      const response = sendGenericEmail(
        token,
        recipients,
        type,
        lng,
        dynamicFields,
        organization,
        files
      );
      dispatch(emailSuccess(response.data));
    } catch (error) {
      dispatch(emailFailure(error.message));
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/emailing.js